module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Group-e8a857c3874446a77160a8e397f2bd7d.svg";